export default __webpack_public_path__ + "static/media/Steffy_Stojanow_AHV_In_Moms_We_Trust.e652608e.jpg";